import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22acf958"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-14 ant-col-xl-16" }, " Preencha os campos do Título a Pagar ", -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-6 ant-col-xl-8" }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { style: {"text-align":"right"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_card = _resolveComponent("card")!
  const _component_titulo_financeiro_centro_custo = _resolveComponent("titulo-financeiro-centro-custo")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"z-index":"999"},
    width: 1200,
    centered: "",
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.tituloFinanceiroBase.status), 1),
            _createElementVNode("span", {
              class: _normalizeClass('ant-badge-status-dot ss-span-status ' + _ctx.tituloFinanceiroBase.classeStatus)
            }, null, 2)
          ])
        ])
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.props.operacao.tipoPermissaoDados != _ctx.EPermissaoDados.Visualizar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Documento",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_documento_financeiro, {
                        codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoTipoDocumentoFinanceiro,
                        "onUpdate:codigoSelecionado": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoTipoDocumentoFinanceiro) = $event)),
                          _cache[2] || (_cache[2] = ($event: any) => (_ctx.atualizarTipoDocumentoFinanceiroSelecionado()))
                        ],
                        empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa],
                        disabled: !_ctx.tituloFinanceiroBase.editavel,
                        contasPagar: true,
                        movimentacaoSaidaPagamentos: (!_ctx.tituloPendente())
                      }, null, 8, ["codigoSelecionado", "empresas", "disabled", "movimentacaoSaidaPagamentos"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_form_item, {
                    label: "Vencimento",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_data, {
                        dataSelecionada: _ctx.tituloFinanceiroBase.titulo.dataVencimento,
                        "onUpdate:dataSelecionada": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.dataVencimento) = $event)),
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                        ],
                        disabled: !_ctx.tituloFinanceiroBase.editavel
                      }, null, 8, ["dataSelecionada", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_selecionar_conta, {
                    codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoConta,
                    "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoConta) = $event)),
                    empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa],
                    disabled: !_ctx.tituloFinanceiroBase.editavel,
                    required: true
                  }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: "Categoria",
                    class: "ss-margin-campos",
                    rules: [{ required: true }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_categoria_plano_conta, {
                        codigoSelecionado: _ctx.tituloFinanceiroBase.titulo.codigoPlanoContaCategoria,
                        "onUpdate:codigoSelecionado": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulo.codigoPlanoContaCategoria) = $event)),
                          _cache[7] || (_cache[7] = ($event: any) => (_ctx.obterCentrosCustoContaContabil()))
                        ],
                        empresas: [_ctx.tituloFinanceiroBase.titulo.codigoEmpresa]
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
            default: _withCtx(() => [
              (_ctx.state.apresentaCentroCusto)
                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                    key: "1",
                    tab: "CENTRO DE CUSTO"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_skeleton, {
                        loading: _ctx.tituloFinanceiroBase.carregandoCentrosCusto
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_titulo_financeiro_centro_custo, {
                            visivel: _ctx.modalBase.computedVisivel,
                            valor: _ctx.tituloFinanceiroBase.titulo.valorTotal,
                            codigoRegistro: _ctx.tituloFinanceiroBase.titulo.codigo,
                            centrosCusto: _ctx.tituloFinanceiroBase.centrosCusto,
                            "onUpdate:centrosCusto": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tituloFinanceiroBase.centrosCusto) = $event)),
                            editavel: _ctx.tituloFinanceiroBase.editavel,
                            exibirValor: false
                          }, null, 8, ["visivel", "valor", "codigoRegistro", "centrosCusto", "editavel"])
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}